module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/flea_type02.90a38aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product_info/flea_type02.png
// module id = Aa6K
// module chunks = 0